import React, {useState, useEffect} from 'react'
import './Contact.css';
import axios from 'axios'
import {motion} from 'framer-motion/dist/framer-motion'
import {options} from '../../Components/options'

function Contact() {
    const initialValues = {firstName: "", lastName: "", subject : "", message: ""}
    let [emailData, setEmailData] = useState(initialValues);
    let [formErrors, setFormErrors] = useState({})
    let [emailStatus, setEmialStatus] = useState(false);
    let [emailSent, setEmailSent] = useState(0)

    const handleData = (el) => {
        let {name, value} = el.target;
        //console.log(el)
        if(el.target.value.length > 0) {
            el.target.classList.add("active")
        }
        else {
            el.target.classList.remove("active")
        }
        setEmailData({...emailData, [name] : value});
    }
    //url = https://portfolioformdata.herokuapp.com/submit
    useEffect(() => {
        //Object.keys gets all mutable properties of the object; cheking if object is empty or equal to 0
        if(Object.keys(formErrors).length === 0 && emailStatus) {
            axios.post("https://portfolioformdata.herokuapp.com/submit", emailData).then(res => {setEmailSent(res.status); console.log("email sent")  }).catch(error => {console.log(error.message); alert(error.message)}) 
            clearInputs() 
        }
    }, [formErrors])

    //clears the inputs after button is submitted SUCCESSFULLY
    function clearInputs() {
        for(let x = 1; x <= 4;x++) {
            let inputs = document.getElementById(`${x}`)
            inputs.value = ''
            inputs.classList.remove("active")
        }
    }

    const validateData = (values) => {
        const errors = {}
        if(!values.firstName) {
            errors.firstName = "Field Required";
        }
        if(values.lastName.length === 0) {
            errors.lastName = "Field Required";
        }
        if(values.subject.length === 0) {
            errors.subject = "Field Required";
        }
        if(values.message.length === 0) {
            errors.email = "Field Required";
        }
        return errors

    }

    function Submit(e) {
        e.preventDefault()
        setEmialStatus(true);
        setFormErrors(validateData(emailData))
    }

    //console.log(Object.keys(formErrors).length)

    return (
        <motion.div 
        initial={options.initial}
        animate={options.animate}
        exit={options.exit}
        onAnimationComplete={() => { window.scrollTo(0,0)}}
        className="Contact__Container">

            <div className="Contact__Container__Left">
                <div className="row-1-inner-container">
                    <div className="contact__header">
                        <h1>Contact Me!</h1>
                    </div>
                    <form className="contactMe">
                        <fieldset>
                            <div className="row-1">
                                <div className="FirstName Name__field field">
                                    <input name="firstName" id="1" data-index="0" className='name' onChange={(el) => handleData(el)}></input>
                                    <span className="placeholder" >First Name: <span className={formErrors.firstName ? "errors" : "none"}> {formErrors.firstName} </span> </span> 
                                    <div className="line"></div>
                                </div>

                                <div className="LastName Name__field field">
                                    <input name="lastName" id="2" data-index="1" onChange={(el) => handleData(el)} className="name"></input>
                                    <span className="placeholder">Last Name: <span className={formErrors.lastName ? "errors" : "none"}> {formErrors.lastName} </span> </span>
                                    <div className="line"></div>
                                </div>
                            </div>

                            <div className="row-2">
                                <div className="Subject Name__field field">
                                    <input  name="subject" id="3"  data-index="2" onChange={(el) => handleData(el)} className="name"></input>
                                    <span className="placeholder">Subject: <span className={formErrors.subject ? "errors" : "none"}> {formErrors.subject} </span></span>
                                    <div className="line"></div>
                                </div>
                            </div>

                            <div className="row-3">
                                <div className="text__field__container field">
                                    <textarea name="message" id="4" className="text__field" data-index="3" onChange={(el) => handleData(el)}> </textarea>
                                    <span className="placeholder"> Message </span>
                                </div>
                            </div>

                            <div className="row-4">
                                               
                                <button className={(emailSent === 200 || !(Object.keys(formErrors).length > 0) ? "submit__button" : "error")} onClick={Submit}>
                                   {(emailSent === 200 ? "submited" : "submit")}
                                </button>
    
                            </div>

                        </fieldset>
                    </form>
                </div>
            </div>
            
            <div className="Contact__Container__Right">
            <iframe src="https://www.google.com/maps/d/u/0/embed?mid=1TcZdRI8Ek7tymKRE6UY7mt1whly2lAtJ&ehbc=2E312F" width="100%" height="100%"></iframe>
            </div>
            
        </motion.div>
    )
}

export default Contact
